import React, { Component } from 'react';
import { Nav, DropdownToggle, DropdownItem, DropdownMenu } from 'reactstrap'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react'
import logo from '../../assets/img/logos/3c.png'
import logo2 from '../../assets/img/logos/3c(2).png'
import { withRouter } from 'react-router'
import { logOut } from "../../actions/logOutActions"
import DataAdapter from '../../adapters/dataAdapter.js'
import { saveMenu } from "../../actions/menuSettingsActions"

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultHeader extends Component {

  constructor(props) {
    super(props)
    this.props = props
  }

  handleLogout = (event) => {
    localStorage.clear()
    this.props.dispatch(logOut())
    this.props.history.push("/")
  }
  refreshpage = (event) => {
    const dataAdapter = new DataAdapter()
    let options = {}
    dataAdapter.GetInformacion(`/auth/menu/paginas`, options, this.getMenuSuccess, this.getMenuError);


  }

  getMenuSuccess = (res) => {
    let menu = [...res.message]
    console.log(menu)
    let menuFinal = { items: menu }
    //guardar en storage menu
    let menuStorage = { menuFinal: menuFinal }
    this.props.dispatch(saveMenu(menuStorage))
    window.location.reload(true);
    this.props.history.push(`/dashboard`)
  }

  getMenuError = (error) => {
    console.log(error)
  }


  render() {
    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <AppNavbarBrand
          full={{ src: logo2, width: 100, height: 40, alt: '3C Group' }}
          minimized={{ src: logo, width: 30, height: 25, alt: '3C Group' }}
        />
        <AppSidebarToggler className="d-md-down-none" display="lg" />

        {/* <Nav className="d-md-down-none" navbar>
          <NavItem className="px-3">
            <NavLink href="/">Dashboard</NavLink>
          </NavItem>
          <NavItem className="px-3">
            <NavLink href="#/users">Users</NavLink>
          </NavItem>
          <NavItem className="px-3">
            <NavLink href="#">Settings</NavLink>
          </NavItem>
        </Nav> */}
        <Nav className="ml-auto" navbar>
          {/* <NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-bell"></i><Badge pill color="danger">5</Badge></NavLink>
          </NavItem>
          <NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-list"></i></NavLink>
          </NavItem>
          <NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-location-pin"></i></NavLink>
          </NavItem> */}
          <AppHeaderDropdown direction="down">
            <DropdownToggle nav>
              {this.props.user !== undefined && this.props.user.avatar !== "" &&
                <img src={this.props.user.avatar} alt={this.props.user.mail} style={{ width: "30px", height: "30px" }} />
              }
              {this.props.user !== undefined && this.props.user.avatar === "" &&
                <span>{this.props.user.mail}</span>
              }
            </DropdownToggle>
            <DropdownMenu right style={{ right: 'auto' }}>
              {/* <DropdownItem header tag="div" className="text-center"><strong>Account</strong></DropdownItem>
              <DropdownItem><i className="fa fa-bell-o"></i> Updates<Badge color="info">42</Badge></DropdownItem>
              <DropdownItem><i className="fa fa-envelope-o"></i> Messages<Badge color="success">42</Badge></DropdownItem>
              <DropdownItem><i className="fa fa-tasks"></i> Tasks<Badge color="danger">42</Badge></DropdownItem>
              <DropdownItem><i className="fa fa-comments"></i> Comments<Badge color="warning">42</Badge></DropdownItem>
              <DropdownItem header tag="div" className="text-center"><strong>Settings</strong></DropdownItem>
              <DropdownItem><i className="fa fa-user"></i> Profile</DropdownItem>
              <DropdownItem><i className="fa fa-wrench"></i> Settings</DropdownItem>
              <DropdownItem><i className="fa fa-usd"></i> Payments<Badge color="secondary">42</Badge></DropdownItem>
              <DropdownItem><i className="fa fa-file"></i> Projects<Badge color="primary">42</Badge></DropdownItem>
              <DropdownItem divider />
              <DropdownItem><i className="fa fa-shield"></i> Lock Account</DropdownItem> */}
              {/* <DropdownItem onClick={this.refreshpage}><i className="fa fa-lock" ></i> Update permission</DropdownItem> */}
              <DropdownItem onClick={this.handleLogout}><i className="fa fa-lock" ></i> Logout</DropdownItem>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
        {/* <AppAsideToggler className="d-md-down-none" /> */}
        {/*<AppAsideToggler className="d-lg-none" mobile />*/}
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

const mapStateToProps = (state) => {
  return {
    menu: state.menuSettings.menu.menuFinal,
    user: state.userSettings.user
  }
}

export default connect(mapStateToProps)(withRouter(DefaultHeader))
